export default __webpack_public_path__ + "resources/icons/n241-8245.png";